import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import withStyles from 'react-jss'

const styles = {
  loadingClassName: {
    transition: 'all 2s ease-in-out',
    opacity: 0
  },
  loadedClassName: {
    transition: 'all 2s ease-in-out',
    opacity: 1
  }
}

const _loaded = {}

class ImageLoader extends React.Component {
  //initial state: image loaded stage
  state = {
    loaded: _loaded[this.props.src]
  }

  //image onLoad handler to update state to loaded
  onLoad = () => {
    _loaded[this.props.src] = true
    this.setState(() => ({ loaded: true }))
  }

  render() {
    const { className, classes, ...props } = this.props

    return (
      <img
        src={this.props.src}
        className={classnames(
          className,
          this.state.loaded ? classes.loadedClassName : classes.loadingClassName
        )}
        onLoad={this.onLoad}
        {...props}
      />
    )
  }
}

export default withStyles(styles)(ImageLoader)

ImageLoader.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired
}
